const {
  stopPropagationAndPreventDefault,
} = require('app/src/stopPropagationAndPreventDefault');
const { View } = require('app/scripts/views/internal/view');
const { Analytics } = require('@trello/atlassian-analytics');
const { sendErrorEvent } = require('@trello/error-reporting');
const { showFlag } = require('@trello/nachos/experimental-flags');
const { l } = require('app/scripts/lib/localize');

const t = require('app/scripts/views/internal/teacupWithHelpers').teacupWithHelpers(
  'org_filtering',
);
const template = t.renderable(({ name, isDeleteable }) => {
  t.form('.js-add-tag-form', () => {
    t.label(() => {
      t.format('name');
      t.input('.js-add-tag-name.js-autofocus', {
        type: 'text',
        value: name,
      });
    });
    t.input('.nch-button.nch-button--primary', {
      type: 'submit',
      value: t.l('save'),
    });
    if (isDeleteable) {
      t.input('.nch-button.nch-button--danger.u-float-right.js-delete-tag', {
        type: 'button',
        value: t.l('delete'),
      });
    }
  });
});

class SetTagView extends View {
  events() {
    return {
      'submit .js-add-tag-form'(e) {
        e.preventDefault();

        const name = this.$('.js-add-tag-name').val().trim();

        if (name) {
          const existingTagWithName = this.getOrganization()?.tagList.find(
            (tag) => tag.get('name') === name,
          );

          if (existingTagWithName === this.model) {
            // They started editing the tag but didn't change anything
            // before clicking save.  We don't need to do anything
            this.onCancel();
          } else if (existingTagWithName) {
            // They tried to name the tag something that already exists
            // Don't bother sending the change to the server, we know
            // it will fail
            this.duplicateAlert();
            this.onCancel();
          } else {
            try {
              if (this.options.boardView) {
                Analytics.sendTrackEvent({
                  action: 'saved',
                  actionSubject: 'collection',
                  source: 'boardMenuDrawer',
                });
              } else {
                Analytics.sendTrackEvent({
                  action: 'saved',
                  actionSubject: 'collection',
                  source: 'workspaceBoardsScreen',
                });
              }
              this.onSubmit(name);
            } catch (err) {
              sendErrorEvent(err, {
                tags: {
                  ownershipArea: 'trello-panorama',
                  feature: 'Collections',
                },
              });
            }
          }
        } else if (this.onDelete) {
          this.onDelete();
        } else {
          this.onCancel();
        }
      },
      'click .js-delete-tag'(e) {
        try {
          stopPropagationAndPreventDefault(e);
          this.onDelete();
        } catch (err) {
          sendErrorEvent(err, {
            tags: {
              ownershipArea: 'trello-panorama',
              feature: 'Collections',
            },
          });
        }
      },
    };
  }

  duplicateAlert() {
    showFlag({
      id: 'edit-tag',
      appearance: 'error',
      title: l('alerts.there is already a collection with that name'),
      msTimeout: 5000,
    });
  }

  getOrganization() {
    return null;
  }

  getName() {
    return '';
  }

  render() {
    this.$el.html(
      template({
        name: this.getName(),
        isDeleteable: this.onDelete,
      }),
    );

    return this;
  }
}

module.exports = SetTagView;
